module.exports = __webpack_public_path__ + "img/01—01—Home Network Overview > Internet-Box Alert.c6e7c637.jpg";